import apiClient from '../utils/apiClient';

export async function getResources(includeArchived = false) {
  const params = includeArchived ? '?include=archived' : '';
  const response = await apiClient.get(`/api/resources${params}`);
  return response.data;
}

export async function getResource(id) {
  const response = await apiClient.get(`/api/resources/${id}`);
  return response.data;
}

export async function createResource(data) {
  const response = await apiClient.post('/api/resources', data);
  return response.data;
}

export async function updateResource(id, data) {
  const response = await apiClient.put(`/api/resources/${id}`, data);
  return response.data;
}

export async function batchUpdateResources(body) {
  const response = await apiClient.patch('/api/resources/batch', body);
  return response.data;
}

export async function archiveResource(id) {
  const response = await apiClient.patch(`/api/resources/${id}/archive`);
  return response.data;
}

export async function restoreResource(id) {
  const response = await apiClient.patch(`/api/resources/${id}/restore`);
  return response.data;
}

export async function createResourceAllocation(data) {
  const response = await apiClient.post('/api/resources/allocations', data);
  return response.data;
}

export async function getResourceAllocations(resourceId) {
  const response = await apiClient.get(`/api/resources/${resourceId}/allocations`);
  return response.data;
}
